import * as React from "react";
import '../custom.css';

export default class Unauthorize  extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <>
                <div className="login-box app-font">
                    <div>
                        <div className="login-logo">
                            {/* <a href="#"><img src="https://www.penguinrandomhouse.com/wp-content/themes/penguinrandomhouse/images/prh-logo.png" alt="PRH-Catalog Search" /></a> */}
                            Inventory Hub
                        </div>
                        <div className="login-box-body">
                            <span className="unauthorize">Unauthorized access!</span>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}


